export class LoadReferralsConditions {
  public static type: string = '[HTTP] LoadReferralsConditions';
}
